import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { ENV } from '@app/env';
import { Comment } from '../models/comment.model';
import * as firebase from 'firebase';
import { Observable } from 'rxjs/Observable';
import { isEmpty, orderBy } from 'lodash';
import { map } from 'rxjs/operators';

@Injectable()
export class CommentData {

  constructor(
    private afStore: AngularFirestore
  ) { }

  public getCommentsByEvent(eventId: string): Observable<any> {
    return this.afStore.collection(ENV.client).doc('comments-events')
      .collection(eventId).valueChanges()
      .pipe(map((data) => {
        if (!isEmpty(data)) {
          return orderBy(data, ['created_at'], ['asc'])
        }
        return data;
      }));
  }

  uploadImages(path: string, images: File[]): Promise<string[]> {
    return Promise.all(images.map(image => {
      const ref = firebase.storage().ref(path).child(image.name);
      const task = ref.put(image);
      return task.then(() => task.snapshot.downloadURL);
    }));
  }

  async saveCommentByEvent(eventId: string, comment: Comment, images: File[]) {
    let id = this.afStore.createId();
    let imageList = [];
    imageList = await this.uploadImages(`/Clients/${ENV.client}/Timeline/${eventId}/${id}`, images);

    return Observable.fromPromise(this.afStore.collection(ENV.client).doc('comments-events')
      .collection(eventId).doc(id).set({
        id: id,
        comment: comment.comment,
        images: imageList,
        userId: comment.userId,
        created_at: firebase.firestore.FieldValue.serverTimestamp()
      }));
  }
}


// WEBPACK FOOTER //
// ./src/providers/comments.ts